import React, { useState } from 'react';
import CardProfile from '../../../components/Profile/Card/'
import { Formik } from 'formik';
import AboutFirm from '../../../components/Forms/Perfil/AboutFirm'
import AboutLawyer from '../../../components/Forms/Perfil/AboutLawyer'

import { validationContactInfoAbout , validationContactInfoAboutFirm} from '../../../utils/validations';
import { makeStyles } from '@material-ui/styles';
import './About.scss';
import { connect } from 'react-redux';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { aboutForm, aboutFirmForm } from '../../../store/actions/UserAction'
import Snackbar from '../../../components/Snackbar';
import TrophieModal from '../../../components/Modal/TrophieModal';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles({
  cardHeader: {
    display: 'block',
    paddingBottom: 0,
    fontSize: 22,
    '&:after': {
      content: '""',
      display: 'block',
      margin: '0 auto',
      width: '100%',
      paddingTop: '8px',
      borderBottom: '1px solid #c1c1c1',
    },
  },
});

const About = (props) => {
  const [ openTrophieModal, setOpenTrophieModal ] = useState(false);
  const [ feedbackMessage, setFeedbackMessage ] = useState({
    open: false,
    message: '',
    variant: 'success'
  });

  const { authClient, aboutForm, aboutFirmForm, trophie, showLoading, hideLoading } = props;

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    showLoading();
    setSubmitting(true);
    if (authClient.role === 'lawyer') {
      const arrayValues = Object.values(values)
      let boolValues = arrayValues.every(elem => elem)
      if (authClient.languages && values.languages.length === 0) {
        boolValues = false
      }
      aboutForm(values, authClient.uid, boolValues).then(res => {
        hideLoading();
        authClient && authClient.awardPerfil && authClient.awardPerfil.about && !authClient.awardPerfil.about && handleOpenTrophieModal()
        setFeedbackMessage({
          open: true,
          message: 'Tus cambios se han guardado con éxito',
          variant: 'success'
        });
    })
    .catch(error => {
      setFeedbackMessage({
        open: true,
        message: 'Ocurrió un error',
        variant: 'error'
      });
      hideLoading();}) 
    } else {
      let achievement = values.expYears != '' && values.gradeStudy != '' && values.officeName != '' ? true : false
      const arrayValues = Object.values(values)
      let boolValues = arrayValues.every(elem => elem);
      if (!values.languages || values.languages.length === 0) {
        boolValues = false
      }

      aboutFirmForm(values, authClient.uid, boolValues, achievement).then(res => {
        hideLoading();
        // authClient && authClient.awardPerfil && authClient.awardPerfil.about && !authClient.awardPerfil.about && 
        if (boolValues === true && !trophie) {
          handleOpenTrophieModal()
        }
        if (boolValues === false || trophie) {
          setFeedbackMessage({
            open: true,
            message: 'Tus cambios se han guardado con éxito',
            variant: 'success'
          });
        }

      })
      .catch(error => {
        console.log('error', error);
        setFeedbackMessage({
          open: true,
          message: 'Ocurrio un error',
          variant: 'error'
        });
        hideLoading();}) 
    }
  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success'
    });
  };

  const handleOpenTrophieModal = () => {
    setOpenTrophieModal(true);
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
  };

 let formValues = {}
 let formValuesFirm = {}
 if (authClient) {
  formValues = {
    name: authClient.name,
    firstLastName: authClient.firstLastName,
    secondLastName: authClient.secondLastName,
    // specialties: [...authClient.specialties],
    phone: authClient.phone,
    cedula: authClient.cedula ? authClient.cedula : '',
    expYears: authClient.expYears,
    colegNumber: authClient.colegNumber,
    languages: authClient.languages ? authClient.languages : [],
    gradeStudy: authClient.gradeStudy,
  }

  formValuesFirm = {
    // specialties: [...authClient.specialties],
    cedula: authClient.cedula ? authClient.cedula : '',
    phone: authClient.phone,
    expYears:authClient.expYears,
    officeName: authClient.officeName,
    languages: authClient.languages ? authClient.languages : [],
  }
 } else {
  formValues = {
    name: '',
    firstLastName: '',
    secondLastName: '',
    // specialties: [],
    phone:'',
    languages: '',
    cedula: '',
    expYears:'',
    gradeStudy: [],
  }
  formValuesFirm = {
    officeName:'',
    cedula: '',
    // specialties:'',
    phone:'',
    expYears:'',
    languages: '',
  };
 }

  return (
    <div className={'about'}>
      <TrophieModal
        open={openTrophieModal}
        trophieValidation={trophie}
        topic="award-profile"
        handleClose={handleCloseTrophieModal}
        title={authClient.role === 'lawFirm' ?
          'Sobre tu despacho' :
          'Sobre ti'
        }
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer='Es importante que tus datos estén correctos ya que serán visibles para los clientes'
      />
      <CardProfile
        title={authClient.role === 'lawFirm' ? 'Sobre tu despacho' : 'Sobre ti'}
        subTitle={authClient.role === 'lawFirm' ? 
        'Coloca el nombre de tu despacho y datos relevantes del mismo.' :
        'Coloca tu nombre y datos personales.'}
        awardIcon
        status={authClient && authClient.awardPerfil.about ? authClient.awardPerfil.about : false}
      >
        <Formik
          initialValues={authClient.role === 'lawyer' ? (formValues): (formValuesFirm)}
          validationSchema={authClient.role === 'lawyer' ? (validationContactInfoAbout): (validationContactInfoAboutFirm)}
          onSubmit={handleSubmit}
          render={props =>(authClient.role === 'lawyer' ? 
            (<AboutLawyer {...props}  createAt={authClient.createAt} />) :
            (<AboutFirm {...props}  createAt={authClient.createAt} />) )
          }
        />

      </CardProfile>
      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' :'80px'}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch =>({
  aboutForm: (data, uid, boolValues) => dispatch(aboutForm(data, uid, boolValues)),
  aboutFirmForm: (data, uid, boolValues) => dispatch(aboutFirmForm(data, uid, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
})

const mapStateToProps = state => ({
  authClient: state.authClient,
  trophie: state.authClient.awardPerfil.about,
});

export default connect(mapStateToProps, mapDispatchToProps)(About);